import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContextComponent";

interface ToggleProps {
  onLabel?: string;
  offLabel?: string;
  onClick?: () => void;
}

const Toggle: React.FC<ToggleProps> = ({
  onLabel = "On",
  offLabel = "Off",
  onClick,
}) => {
  const { userInfo } = useContext(AuthContext);
  const [isOn, setIsOn] = useState<boolean>(userInfo?.theme === "DARK");

  const toggleSwitch = () => {
    setIsOn((prev) => !prev);
    if (onClick) {
      onClick();
    }
  };

  // Update the theme based on the toggle state
  useEffect(() => {
    if (isOn) {
      // Set theme to DARK
      // Call your function to update the theme here
      // e.g., handleThemeSwitch()
    } else {
      // Set theme to LIGHT
      // Call your function to update the theme here
      // e.g., handleThemeSwitch()
    }
  }, [isOn]);

  return (
    <div className="flex items-center relative">
      <span
        className={`absolute transition-all duration-200 ${
          isOn ? "left-14" : "right-14"
        }${isOn ? "text-white left-14" : "text-black right-14"}`}
      >
        {isOn ? onLabel : offLabel}
      </span>
      <div
        onClick={toggleSwitch}
        role="button"
        aria-pressed={isOn}
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && toggleSwitch()}
        className={`relative inline-block w-12 h-6 border-2 rounded-full cursor-pointer transition-colors 
                    ${isOn ? "border-red-500" : "border-gray-400"}`}
      >
        <div
          className={`absolute left-1 top-1 w-4 h-4 bg-red-600 -mt-0.5 rounded-full transition-transform 
                        ${isOn ? "transform translate-x-5 -mt-0.5" : ""}`}
        />
      </div>
    </div>
  );
};

export default Toggle;
